// export const Url = "http://localhost:8080" 
export const Url = "https://api.deviandshera.com" 
// export const Url = "https://www.doozie-do.co"
// export const Url = "https://www.doozie-do.shop"

// export const awsFileUrl = 'https://doozie.s3.ap-south-1.amazonaws.com'
export const awsFileUrl = 'https://deviandshera-assets.s3.ap-south-1.amazonaws.com'

export const orderStatusMessage = {
    pending: 'Pending',
    confirmed: 'Confirmed',
    processing: 'Processing',
    dispatched : "dispatched",
    'out for delivery' : "out for delivery",
    delivered: 'delivered',
    cancelled: 'cancelled'
} 